import { useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import { Select, Switch, Table } from "antd";
import { useDispatch } from "react-redux";
import { BsPencilSquare, BsSearch } from "react-icons/bs";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../../constant/reportType";
import { COUNTRY_COLUMN, STATE_COLUMN } from "../../constant/AppConstant";
import { useDeleteCountryMutation, useGetAllCountryMutation, useGetAllCountryWithSearchMutation } from "../../redux-toolkit/services/countryService";
import { useDeleteStateMutation, useGetAllStatesMutation, useGetAllStatesWithSearchMutation, useUpdateStateMutation } from "../../redux-toolkit/services/stateService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { getAllcountryDetail, setcountry } from "../../redux-toolkit/slices/countrySlice";
import { getAllStatesTotalRecords, getAllStatesWithPaginationDetails, setAllStatesWithPagination } from "../../redux-toolkit/slices/statesSlice";
import { alertMessage } from "../../utils/AlertService";
import Loading from "../Loading";
import CommonData from "./CommonData";
import Button from 'react-bootstrap/Button';

const { Option } = Select;
type Props = {};
const Common = (props: Props) => {

  const params = useParams();
  const token: any = getLocalStorageData("localUser").token;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // States
  const [show, setShow] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [currentpage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [reportName, setReportName]: any = useState();
  const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
  const [selectedRow, setSelectedRow]: any = useState([]);
  const [isSelect, setIsSelect] = useState(false);
  const [call, setCall] = useState("N");
  const [stateData, setStateData] = useState([]);
  const [columData, setColumnData]: any = useState();

  //datasource
  const [countryDataSource, setCountryDataSource]: any = useState([]);
  const [stateDataSource, setStateDataSource]: any = useState([]);

  //get mutation
  const [getAllCountry, getAllCountryResponse] = useGetAllCountryMutation();
  const [getAllState, getAllStateResponse] = useGetAllStatesMutation();

  //delete mutation
  const [deleteCountry, deleteCountryResponse] = useDeleteCountryMutation();
  const [deleteState, deleteStateResponse] = useDeleteStateMutation();

  const [updateState, updateStateResponse] = useUpdateStateMutation();

  //selector
  const allCountry: any = useAppSelector(getAllcountryDetail);
  const allState: any = useAppSelector(getAllStatesWithPaginationDetails);
  const allStatesTotalRecords: any = useAppSelector(getAllStatesTotalRecords);

  //search
  const [getAllStatesWithSearch, getAllStatesWithSearchResponse] = useGetAllStatesWithSearchMutation();
  const [getAllCountriesWithSearch, getAllCountriesWithSearchResponse] = useGetAllCountryWithSearchMutation();

  useEffect(() => {
    switch (params.reportType) {
      case REPORT_PATH.COUNTRY:
        setReportName(REPORT_NAME.COUNTRY)
        break;
      case REPORT_PATH.STATE:
        setReportName(REPORT_NAME.STATE)
        break;
      default:
    }
  }, [params.reportType]);

  useEffect(() => {
    const temp: any = [];
    const tempAction: any = {
      title: "Action",
      dataIndex: "action",
      key: "name",
      fixed: "right",
      width: 120,
      render: (index: any, record: any) => {
        return (
          // for delete switch button
          <div className="d-flex justify-content-between">
            <div className="px-2 pe-auto">
              <Switch
                className={`${record.status === true ||
                  record.enabled === true ||
                  record.isActive === true ? "bg-black" : "bg-secondry"}`}
                checked={
                  record.status === true ||
                    record.enabled === true ||
                    record.isActive === true
                    ? true
                    : false
                }
                onClick={() => {
                  onDeleteData(record);
                }}
              />
            </div>
            {record.status === true ||
              record.enabled === true ||
              record.isActive === true ? (
              <div
                className="px-2 pe-auto"
                onClick={() => {
                  handleOpenForm(record);
                }}
              >
                <BsPencilSquare size={18} />
              </div>
            ) : null}
          </div>
        );
      },
    };

    if (reportName === REPORT_NAME.STATE && STATE_COLUMN) {
      STATE_COLUMN.map((item: any) => {
        temp.push(item);
      });
      temp.push(tempAction);
      setColumnData(temp);
    } else if (reportName === REPORT_NAME.COUNTRY && COUNTRY_COLUMN) {
      COUNTRY_COLUMN.map((item: any) => {
        temp.push(item);
      });
      temp.push(tempAction);
      setColumnData(temp);
    }
  }, [reportName, params.reportType]);

  useEffect(() => {
    if (reportName === REPORT_NAME.STATE) {
      setIsSelect(true);
      getAllCountry({});
      getAllState({ page: currentpage - 1, offset: offset, orderBy: "asc" });
    } else if (reportName === REPORT_NAME.COUNTRY) {
      setIsSelect(false);
      getAllCountry({});
    }
  }, [reportName]);

  useEffect(() => {
    if (call === "Y") {
      if (reportName === REPORT_NAME.STATE) {
        setIsSelect(true);
        getAllState({ page: currentpage - 1, offset: offset, orderBy: "asc" });
        setCall("N");
      } else if (reportName === REPORT_NAME.COUNTRY) {
        setIsSelect(false);
        getAllCountry({});
        setCall("N");
      }
    }
  }, [call]);

  useEffect(() => {
    if (allCountry) {
      setCountryDataSource(allCountry);
    }
  }, [allCountry]);

  useEffect(() => {
    if (allState) {
      setStateDataSource(allState);
    }
  }, [allState]);

  useEffect(() => {
    if (getAllCountryResponse.isSuccess) {
      dispatch(setcountry(getAllCountryResponse));
    } else if (getAllCountryResponse.isError) {
      let response: any = getAllCountryResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllCountryResponse.isSuccess, getAllCountryResponse.isError]);

  useEffect(() => {
    if (getAllStateResponse.isSuccess) {
      dispatch(setAllStatesWithPagination(getAllStateResponse));
    } else if (getAllStateResponse.isError) {
      let response: any = getAllStateResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllStateResponse.isSuccess, getAllStateResponse.isError]);

  //delete..........
  const onDeleteData = (record: any) => {
    if (reportName === REPORT_NAME.COUNTRY) {
      deleteCountry({
        token: token,
        id: record.id,
      });
    } else if (reportName === REPORT_NAME.STATE) {
      deleteState({
        token: token,
        id: record.id,
      });
    }
  };

  useEffect(() => {
    if (updateStateResponse.isSuccess) {
      alertMessage("State updated successfully", "success");
      setCall("Y");
    } else if (updateStateResponse.isError) {
      let response: any = updateStateResponse?.error;
      alertMessage(response, "error");
    }
  }, [updateStateResponse.isSuccess, updateStateResponse.isError]);

  useEffect(() => {
    if (deleteCountryResponse.isSuccess) {
      alertMessage("Country status updated successfully", "success");
      setCall("Y");
    } else if (deleteCountryResponse.isError) {
      let response: any = deleteCountryResponse.error;
      alertMessage(response, "error");
    }
  }, [deleteCountryResponse.isSuccess, deleteCountryResponse.isError]);

  useEffect(() => {
    if (deleteStateResponse.isSuccess) {
      alertMessage("State status updated successfully", "success");
      setCall("Y");
    } else if (deleteStateResponse.isError) {
      let response: any = deleteStateResponse.error;
      alertMessage(response, "error");
    }
  }, [deleteStateResponse.isSuccess, deleteStateResponse.isError]);

  const handleOpenForm = (record: any) => {
    setShow(true);
    setActionType(ACTION_TYPE.UPDATE_ACTION);
    setSelectedRow(record);
  };

  const paginationChange = (page: number, offset: number) => {
    if (reportName === REPORT_NAME.STATE) {
      getAllState({
        page: page - 1,
        offset: offset,
        orderBy: "asc",
      });
    } else if (reportName === REPORT_NAME.STATE) {
      getAllCountry({
        page: page - 1,
        offset: offset,
        orderBy: "asc",
      });
    }
    setCurrentPage(page);
    setOffset(offset);
  };

  const handleShow = () => setShow(true);

  const buildStateData = (data: any) => {
    let temp: any = [];
    data.forEach((element: any) => {
      // let payload =
      temp.push({
        id: element.id,
        name: element.name,
        countryName: element.country.name === null ? "-" : element.country.name,
        countryId: element.countryId === null ? "-" : element.countryId,
        status: element.status,
      });
    });
    setStateData(temp);
  };

  useEffect(() => {
    if (stateDataSource) {
      buildStateData(stateDataSource);
    }
  }, [stateDataSource]);

  const handleSearch = (event: any) => {
    // if ((event.target.value).length >= 3 || event.target.value == 0) {
    if (reportName === REPORT_NAME.STATE) {
      getAllStatesWithSearch({
        token: token,
        payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
      });
    } else if (reportName === REPORT_NAME.COUNTRY) {
      getAllCountriesWithSearch({
        token: token,
        payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
      });
    }
    // }
  };

  useEffect(() => {
    if (getAllStatesWithSearchResponse.isSuccess) {
      dispatch(setAllStatesWithPagination(getAllStatesWithSearchResponse));
    } else if (getAllStatesWithSearchResponse.isError) {
      let response: any = getAllStatesWithSearchResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllStatesWithSearchResponse.isSuccess, getAllStatesWithSearchResponse.isError]);

  useEffect(() => {
    if (getAllCountriesWithSearchResponse.isSuccess) {
      dispatch(setcountry(getAllCountriesWithSearchResponse.data));
    } else if (getAllCountriesWithSearchResponse.isError) {
      let response: any = getAllCountriesWithSearchResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllCountriesWithSearchResponse.isSuccess, getAllCountriesWithSearchResponse.isError]);

  return (
    <div className="mt-2 overflow-y-auto">
      {/* navigate */}
      <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
        <div className="d-flex align-items-center w-100 px-2">
          <h5
            className="m-0 px-0 d-flex align-items-center text-cm-active-primary1"
            style={{ fontWeight: "700" }}
          >
            {reportName}
          </h5>
        </div>
        <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
          <div className="input-group px-2 mt-1">
            <Form.Control
              type="search"
              placeholder="Search"
              className="border-0 bg-cm-light-primary1"
              aria-label="Search"
              onChange={handleSearch}
            />
            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
              <span className="input-group-text bg-cm-light-primary1 border-0">
                {/* <img src={gear} alt="" /> */}
                <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
              </span>
            </div>
          </div>
          <div onClick={handleShow} className="d-flex px-2 align-items-center mt-1">
            <Button
              variant="dark"
              className="d-flex align-items-center me-0 text-nowrap"
              onClick={() => setActionType(ACTION_TYPE.ADD_ACTION)}
            >
              <BiPlus />
              Add
            </Button>
          </div>
          {show && (
            <CommonData
              show={show}
              setShow={setShow}
              actionType={actionType}
              getAllReportAsync={() => null}
              updateAllReportAsync={({ }) => null}
              reportName={reportName}
              isSelect={isSelect}
              data={selectedRow}
              call={call}
              setCall={setCall}
            />
          )}
        </div>
      </div>

      <div className="d-flex ">
        {getAllCountryResponse.isLoading ||
          getAllStateResponse.isLoading ||
          getAllCountriesWithSearchResponse.isLoading ||
          getAllStatesWithSearchResponse.isLoading ? (
          <Loading />
        ) : (
          ""
        )}
      </div>
      <div className="my-2 w-100 overflow-x-auto rounded-3">
        <Table
          bordered={true}
          rowKey={"id"}
          pagination={
            reportName === REPORT_NAME.STATE
              ? {
                total: allStatesTotalRecords && allStatesTotalRecords,
                responsive: true,
                current: currentpage,
                showSizeChanger: true,
                pageSizeOptions: [15, 20, 30],
                onChange: (page, offset) => {
                  paginationChange(page, offset);
                },
                pageSize: offset,
              }
              : {
                responsive: true,
              }
          }
          columns={columData}
          dataSource={
            reportName === REPORT_NAME.STATE
              ? stateData
              : reportName === REPORT_NAME.COUNTRY
                ? countryDataSource
                : ""
          }
        />
      </div>
    </div>
  );
};

export default Common;
